import { mapState, mapMutations } from 'vuex';
import { validationFormMixin } from '../../../shared/mixins/validationFormMixin';
import {
  fetchTrainingField,
  createTrainingField,
  updateTrainingField,
  deleteTrainingField,
} from '../../helpers/KnGroupsOptions';
import KnFormSubtitle from '../../../shared/components/KnFormSubtitle/KnFormSubtitle.vue';
import KnFormActionButtons from '../../../shared/components/KnFormActionButtons/KnFormActionButtons.vue';
import KnPagination from '../../../shared/components/KnPagination.vue';
import { paginationMixin } from '@/modules/shared/mixins/paginationMixin';

export default {
  components: {
    KnFormSubtitle,
    KnFormActionButtons,
    KnPagination,
  },
  mixins: [paginationMixin, validationFormMixin],
  data() {
    return {
      errors: [],
      valid: true,
      trainingField: {
        id: 'NA', // No asignado
        nombre: null,
        descripcion: null,
        id_institucion_educativa: null,
      },
      trainingFields: [],
      toUpdate: false,
      showInactive: false,
      loading: false,
    };
  },
  computed: {
    ...mapState(['institutionId']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Crear';
    },
    invalidFields() {
      return this.objectHasNulls(this.trainingField);
    },
  },
  async created() {
    this.setIsLogin(false);
    await this.getPaginateTrainingField(1);
    this.trainingField.id_institucion_educativa = this.institutionId;
  },
  watch: {
    showInactive: {
      async handler() {
        await this.getPaginateTrainingField(1);
      },
    },
    institutionId: {
      async handler() {
        this.setIsLogin(false);
        await this.getPaginateTrainingField(1);
        this.trainingField.id_institucion_educativa = this.institutionId;
      },
    },
  },
  methods: {
    ...mapMutations(['setIsLogin']),
    async getPaginateTrainingField(page = 1) {
      try {
        this.trainingFields = [];
        this.setPaginationPage(page);

        if (!this.loading) {
          this.loading = true;

          const { ok, data, message, count } = await fetchTrainingField({
            institutionId: this.institutionId,
            systemStatus: !this.showInactive,
            limit: this.pagination.limit,
            offset: this.pagination.offset,
          });

          if (ok) {
            this.setPaginationCount(count);
            for (const trainingFields of data) {
              this.trainingFields.push({ ...trainingFields });
            }
          } else {
            console.error(
              'No se pudieron obtener los campos formativos',
              message
            );
          }
          this.loading = false;
        }
      } catch (error) {
        console.error('Error al obtener los campos formativos:', error);
        this.loading = false;
      }
    },

    async save() {
      if (this.toUpdate) {
        await updateTrainingField(
          this.trainingField.id,
          this.trainingField.nombre,
          this.trainingField.descripcion,
          this.institutionId
        );
        this.toUpdate = false;
        await this.getPaginateTrainingField(1);
      } else {
        await createTrainingField(
          this.trainingField.nombre,
          this.trainingField.descripcion,
          this.institutionId
        );
        this.clear();
        await this.getPaginateTrainingField(1);
      }
      this.clear();
    },
    clear() {
      this.trainingField = {
        id: 'NA', // No asignado
        nombre: null,
        descripcion: null,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    clearInline() {
      this.trainingField = {
        id: 'NA', // No asignado
        nombre: null,
        descripcion: null,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    edit(item) {
      this.trainingField = { ...item };
      // console.log("Item a editar:", this.evaluationTypes);
      this.toUpdate = true;
    },
    async deleteInline(itemId) {
      await deleteTrainingField(itemId);
      await this.getPaginateTrainingField(1);
      this.clearInline();
    },
  },
};
